import React, { ReactNode } from 'react';
import { Admin, CustomRoutes, EditGuesser, Layout, LayoutProps, ListGuesser, Resource } from 'react-admin';
import { authProvider } from './authentication/authProvider';
import { Route, BrowserRouter } from 'react-router-dom';
import categories from './categories';
import clients from './clients';
import contracts from './contracts';
import dataProviders from './dataProviders/dataProviders';
import funerals from './funerals';
import { i18nProvider } from './i18n/i18nProvider';
import invoices from './invoices';
import items from './items';
import places from './places';
import { mainTheme } from './layout/themes';
import { LoginCallback } from './authentication/LoginCallback';
// import { LoginPage } from './authentication/LoginPage';
import payments from './payments';
import { MyAppbar } from './layout/MyAppbar';
import dataProvidersWithSearch from './dataProviders/dataProviders';
import { AppLocationContext, Breadcrumb } from "@react-admin/ra-navigation";
import clergy from './clergy';
import coroners from './coroners';
import creditmemos from './creditmemos';
import { MyBreadcrumb } from './layout/MyBreadcrumb';
import Schedule from './funerals/Schedule';
import { MyMenu } from './layout/MyMenu';
import comments from './comments';
import subscriptions from './subscriptions';
import settings from './settings';
import profiles from './profiles';
import LogoutPage from './components/LogoutPage';
import { AftercarePage } from './aftercare/AftercarePage';
import { CoronerPayments } from './funerals/CoronerPayments';
import { LoginPage, SetPasswordPage, ForgotPasswordPage } from 'ra-supabase';

import quotes from './quotes';
import Partners from './partners';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import deliveries from './deliveries';
import analytics from './analytics';
import leads from './leads';
import { MonthlyRecapPage } from './analytics/MonthlyRecapPage';
import { PricingPage } from './pricing/PricingPage';
import stripe from './stripe';
import Phase0Page from './phase0/Phase0Page';
import { LeadShow } from './leads/LeadShow';
import SiedPage from './sied/SiedPage';
import { InboxDockProvider } from './inbox/InboxDock';
import InboxPage from './inbox/InboxPage';
import { SeoPage } from './seo/SeoPage';
import PartnerReconciliationList from './partner-reconciliation/PartnerReconciliationList';
import InvoiceDetailPage from './partner-reconciliation/InvoiceDetailPage';
import PartnerMonthPage from './partner-reconciliation/PartnerMonthPage';
import ProfitabilityPage from './profitability/ProfitabilityPage';


const MyLayout = ({ children, ...rest }: LayoutProps) => (
    <AppLocationContext>
      <InboxDockProvider>
        <Layout {...rest} appBar={MyAppbar} menu={MyMenu}>
          {/* <MyBreadcrumb /> */}
          {children}
        </Layout>
      </InboxDockProvider>
  </AppLocationContext>
)

// const MyLayout = ({...props }) => (
//     <Layout {...props} appBar={MyAppbar} />
// )

function App() {
  return (
    <BrowserRouter>
    <Admin
      layout={MyLayout}
      title="Paperman Admin"
      dataProvider={dataProvidersWithSearch}
      authProvider={authProvider}
      i18nProvider={i18nProvider}
      theme={mainTheme}
      requireAuth
      disableTelemetry
      loginPage={<LoginPage providers={['google']} />}
    >
      <Resource name="funerals" {...funerals} />
      <Resource name="analytics" {...analytics} />
      <Resource name="clients" {...clients} />
      <Resource name="contracts" {...contracts} />
      <Resource name="deliveries" {...deliveries} />
      <Resource name="quotes" {...quotes} />
      <Resource name="leads" {...leads} show={LeadShow} />
      <Resource name="payments" {...payments} />
      <Resource name="places" {...places}/>
      <Resource name="clergy" {...clergy} options={{ label: 'Clergy' }}/>
      <Resource name="coroners" {...coroners} options={{ label: 'Coroners' }}/>
      <Resource name="funeral_coroners" />
      <Resource name="categories" />
      <Resource name="items" {...items} />
      <Resource name="invoices" {...invoices} />
      <Resource name="creditmemos" {...creditmemos} />
      <Resource name="comments" {...comments} />
      <Resource name="subscriptions" {...subscriptions} />
      <Resource name="settings" {...settings} />
      <Resource name="profiles" {...profiles} options={{ label: 'Team' }} />
      <Resource name="partners" {...Partners} icon={LocalShippingIcon} />
      <Resource name="sb_payments" {...stripe} />

      {/* <Resource name="settings" list={<ListGuesser />} edit={<EditGuesser />} /> */}

      {/* <Resource name="accounts" list={<ListGuesser />} /> */}
      <Resource name="taxes" list={<ListGuesser />} />
      
      <Resource name="paymentmethods" />
      <Resource name="form_audit_log" />
      <Resource name="agent_runs" />
      <Resource name="inbox_items" />
      <Resource name="inbox_dismissals" />
      <CustomRoutes>
        <Route path="/login/callback/" element={<LoginCallback />} />
        <Route path="/schedule/:date" element={<Schedule />} />
        <Route path="/schedule/" element={<Schedule />} />
        <Route path="/aftercare/" element={<AftercarePage />} />
        <Route path="/phase-0" element={<Phase0Page />} />
        <Route path="/coroner-payments" element={<CoronerPayments />} />
        <Route path="/monthly-recap" element={<MonthlyRecapPage />} />
        <Route path="/sied" element={<SiedPage />} />
        <Route path="/seo" element={<SeoPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/partner-reconciliation" element={<PartnerReconciliationList />} />
        <Route path="/partner-reconciliation/:id" element={<InvoiceDetailPage />} />
        <Route path="/partner-reconciliation/partner/:partnerId/:month" element={<PartnerMonthPage />} />
        <Route path="/profitability" element={<ProfitabilityPage />} />
        <Route path="/inbox" element={<InboxPage />} />

      </CustomRoutes>
      <CustomRoutes noLayout>
      <Route
            key="logout"
            path="/logout"
            element={<LogoutPage />}
        />
        </CustomRoutes>

    </Admin>
    </BrowserRouter>
  );
}

export default App;